import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'as0038',
    ecrans: ['00-2'],
    params:['?atfcleint',
            '?stamnetab']
});
